/**
 * @class
 * @extends mkE.Base
 */
T.InstagramFeed = Class(
	/**
	 * @lends {T.InstagramFeed#}
	 */
	{
		COUNT: 10,

		/**
		 * @param {DR.ApiCall|null} apiCall
		 * @private
		 */
		__construct( apiCall ) {
			this.node = mkE({
				tag: 'div',
				id: 'instagram_feed',
				className: 'container',
				els: [
					{
						tag: 'div',
						className: 'header',
						els: [
							{
								tag: 'h2',
								text: D.Lang.get('event.instagram.h2')
							},
							this.linkNode = mkE({
								tag: 'a',
								href: 'https://www.instagram.com/roadgames_world/',
								attr: {
									rel: 'nofollow'
								},
								text: D.Lang.get('event.instagram.link')
							})
						]
					},
					this._instagramFeedContainer = mkE({
						tag: 'div',
						className: 'items',
						style: {
							// inline for cls
							display: 'grid',
							gridTemplateColumns: 'repeat(5,1fr)',
							gridTemplateRows: 'repeat(2,1fr)',
							gap: '16px'
						},
						els: this._getPlaceHolders()
					})
				]
			});

			this._mGetInstagramFeed = new DR.web.GetInstagramFeed();
			this._mGetInstagramFeed.pg = 1;
			this._mGetInstagramFeed.count = this.COUNT;
			this._mGetInstagramFeed.select = [
				new DR.roadgames.select.Image().medium()
			];
			this._mGetInstagramFeed.onLoad = this._mGetInstagramFeedRe;
			if( apiCall ) {
				apiCall.addMethod(this._mGetInstagramFeed);
			} else {
				this._mGetInstagramFeed.call();
			}
		},

		_getPlaceHolders() {
			let items = [];
			for( let i = 0; i < this.COUNT; i++ ) {
				items.push({
					tag: 'span',
					className: 'item item-placeholder'
				});
			}
			return items;
		},

		_mGetInstagramFeedRe() {
			clearNode(this._instagramFeedContainer);
			for( let i = 0; i < this._mGetInstagramFeed.re.items.length; i++ ) {
				const item = this._mGetInstagramFeed.re.items[i];
				mkE({
					tag: 'a',
					className: 'item',
					href: item.url,
					attr: {
						rel: 'nofollow'
					},
					els: [
						{
							tag: 'img',
							loading: 'lazy',
							src: item.image.medium
						}
					]
				}).append(this._instagramFeedContainer);
			}
			if( this._mGetInstagramFeed.re.username ) {
				this.linkNode = mkE({
					tag: 'a',
					href: 'https://www.instagram.com/' + this._mGetInstagramFeed.re.username,
					attr: {
						rel: 'nofollow'
					},
					text: D.Lang.get('event.instagram.link').replace('@roadgames_world', '@' + this._mGetInstagramFeed.re.username)
				}).replace(this.linkNode);
			}
		}
	},
	mkE.Base
);